module.exports = __webpack_public_path__ + "static/img/case-2dayin.5db15c31.jpg";